export interface ColumnSortData {
    sortDirection: ColumnSortDirection;
    sortProperty: string;
}

export enum ColumnSortDirection {
    None,
    Asc,
    Desc
}
